module.exports = {
  USE_EDI_REQUEST: 'USE_EDI_REQUEST',
  USE_EDI_SUCCESS: 'USE_EDI_SUCCESS',
  USE_EDI_FAILURE: 'USE_EDI_FAILURE',
  USE_MAX_REQUEST: 'USE_MAX_REQUEST',
  USE_MAX_SUCCESS: 'USE_MAX_SUCCESS',
  USE_MAX_FAILURE: 'USE_MAX_FAILURE',
};
